module.exports = __webpack_public_path__ + "img/mobilitaet.eeef302a.png";